// ReportDataForDevicesRequest.
//
// Class representing a report data request given selected devices.
export class ReportDataForDevicesRequest {
  public descending: boolean;
  public endDate: Date | undefined;
  public includeVerifiedPassagesOnly: boolean;
  public page: number;
  public rowsPerPage: number;
  public sortBy: string;
  public startDate: Date | undefined;
  public uidList: number[] | undefined;
  // EN-11: optional filters. A marker is only valid together with its pig run.
  public pigRunId?: number;
  public pipelineSectionMarkerId?: number;

  public constructor() {
    this.page = -1;
    this.rowsPerPage = -1;
    this.sortBy = '';
    this.descending = false;
    this.includeVerifiedPassagesOnly = false;
  }
}
